import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import PerformanceResourceLibraryPage from "@/pages/admin/PerformanceResourceLibraryPage";

export const Route = createFileRoute("/_admin/admin/performance/resources")({
  head: () => pageHead("Admin · Performance · Resources", "AKIVA admin · performance · resources portal.", "/admin/performance/resources", true),
  component: PerformanceResourceLibraryPage,
});
